<div class="modal-content" *ngIf="(basketorderList || []).length > 0">
  <div class="modal-header">
    <button type="button" class="close pull-right align-middle" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <h4 class="modal-title align-middle" jhiTranslate="modals.billNoPaid.title"></h4>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger d-flex flex-row align-items-center mb-1" role="alert">
      <mdb-icon size="2x" fas icon="exclamation-circle" class="text-danger mr-2 mr-sm-3"></mdb-icon>
      <div jhiTranslate="{{ basketorderList?.length === 1 ? 'modals.billNoPaid.subTitle.bill' : 'modals.billNoPaid.subTitle.bills' }}"></div>
    </div>
    <span jhiTranslate="modals.billNoPaid.subTitle.info" class="d-block text-right mr-2 fs-6 info"></span>

    <div *ngFor="let basketOrder of basketorderList" class="row align-items-center">
      <span
        class="col-7 text-center"
        jhiTranslate="modals.billNoPaid.buttons.billNumber"
        [translateValues]="{ billNumber: basketOrder.billNumber, price: basketOrder.price }"
      ></span>
      <button class="btn btn-primary col-4" (click)="goToPaymentForm(basketOrder)">
        {{ 'label-cta.pay' | translate }}
      </button>
    </div>
  </div>
</div>
